
import React from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { AdminLayout } from '../components/admin/AdminLayout';
import { AdminLogin } from '../components/admin/AdminLogin';
import { AdminDashboard } from '../components/admin/AdminDashboard';
import { AdminUsers } from '../components/admin/AdminUsers';
import { AdminWorkers } from '../components/admin/AdminWorkers';
import { AdminJobs } from '../components/admin/AdminJobs';
import { AdminSettings } from '../components/admin/AdminSettings';
import { AdminMessages } from '../components/admin/AdminMessages';
import { AdminFirebaseSettings } from '../components/admin/AdminFirebaseSettings';
import { AdminCustomAds } from '../components/admin/AdminCustomAds';
import { AdminCategories } from '../components/admin/AdminCategories';
import { AdminReports } from '../components/admin/AdminReports';
import { AdminCMS } from '../components/admin/AdminCMS';
import { AdminWithdrawals } from '../components/admin/AdminWithdrawals';
import { AdminAdministrators } from '../components/admin/AdminAdministrators';
import { UserRole, UserProfile } from '../types';
import { useSession } from '../context/SessionContext';

export const AdminRoutes: React.FC = () => {
    const [isAdminAuthenticated, setIsAdminAuthenticated] = React.useState(() => localStorage.getItem('hh_admin_session') === 'active');
    const { feeConfig, setFeeConfig, serviceCategories, userProfile } = useSession(); // Access global context if needed

    // Mock Admin Profile if used
    const adminProfile: UserProfile = {
        firstName: 'Super', lastName: 'Admin', email: 'admin@system.local', phone: '0000000000',
        role: UserRole.ADMIN, gender: 'Male', dob: '', avatarUrl: 'https://ui-avatars.com/api/?name=Admin',
        status: 'active', adminPermissions: []
    };

    if (!isAdminAuthenticated) {
        return (
            <AdminLogin onLoginSuccess={() => {
                localStorage.setItem('hh_admin_session', 'active');
                setIsAdminAuthenticated(true);
            }} />
        );
    }

    return (
        <Routes>
            <Route element={
                <AdminLayout
                    currentUser={adminProfile}
                    onLogout={() => {
                        localStorage.removeItem('hh_admin_session');
                        setIsAdminAuthenticated(false);
                    }}
                    categories={serviceCategories}
                    onUpdateCategories={() => { }}
                    feeConfig={feeConfig}
                    onUpdateFeeConfig={() => { }}
                />
            }>
                <Route index element={<Navigate to="dashboard" replace />} />
                <Route path="dashboard" element={<AdminDashboard />} />
                <Route path="users" element={<AdminUsers />} />
                <Route path="administrators" element={<AdminAdministrators />} />
                <Route path="workers" element={<AdminWorkers />} />
                <Route path="jobs" element={<AdminJobs />} />
                <Route path="categories" element={<AdminCategories categories={serviceCategories} onUpdateCategories={(cats) => { console.log('Update Cats (Ctx)'); /* Connect to Context if needed */ }} />} />
                <Route path="messages" element={<AdminMessages />} />
                <Route path="ads" element={<AdminCustomAds />} />
                <Route path="cms" element={<AdminCMS />} />
                <Route path="withdrawals" element={<AdminWithdrawals />} />
                <Route path="firebase" element={<AdminFirebaseSettings />} />
                <Route path="settings" element={<AdminSettings feeConfig={feeConfig} onUpdateFeeConfig={setFeeConfig} />} />
                <Route path="reports" element={<AdminReports />} />
            </Route>
        </Routes>
    );
};
